var style = {"z-snackbar-queue":"z-snackbar-queue","z-snackbar":"z-snackbar","z-snackbar-queue--empty":"z-snackbar-queue--empty"};

export { style as default };
//# sourceMappingURL=SnackbarQueue.module.scss.js.map
